export default "__VITE_ASSET__D6QnW4LD__"